import script from "./V4GlobalSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./V4GlobalSearch.vue?vue&type=script&setup=true&lang=js"

import "./V4GlobalSearch.vue?vue&type=style&index=0&id=2a0e5d54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0e5d54"]])

export default __exports__